<template>
  <FormContainer
    id="modules-tableau-scroll"
  >
    <template #title>Montant demandé</template>
    <template #message>
      <BasicAlert
        alertType="info"
        alertLabel="Le chiffrage ci-dessous est une estimation. Le taux indiqué est un taux de base, il pourra être modifié au moment du traitement du dossier."
      />
    </template>
    <template #content>
      <!-- Desktop version -->
      <div class="elements--desktop">
        <div class="cardLayoutWrapper cardLayoutWrapper--header">
          <div class="elem elem--span-2"></div>
          <div class="elem elem--span-8">
            <span>Type de module</span>
          </div>

          <div class="elem elem--span-6">
            <span>Heures demandées</span>
          </div>
          <div class="elem elem--span-6">
            <span>Taux (€/h)</span>
          </div>
          <div class="elem elem--span-7">
            <span>Nombre de contrats</span>
          </div>
          <div class="elem elem--span-7">
            <span>Montant demandé HT</span>
          </div>
        </div>

        <div
          v-for="(montant, index) in listeMontantsDemandes"
          class="listCardDesktopWrapper"
          :key="index"
        >
          <div
            class="cardLayoutWrapper cardLayoutWrapper--selectionnable"
          >
            <div class="elem elem--span-2">

            </div>
            <div class="elem elem--span-8">
              <BasicText>{{ getModuleLabel(index) }}</BasicText>
            </div>
            <div class="elem elem--span-6">
              <BasicText>{{ formatNumber(montant.heuresDemandees, { decimal: 2, separateur: true })  }}</BasicText>
            </div>
            <div class="elem elem--span-6">
              <BasicText>{{ montant.taux }}</BasicText>
            </div>
            <div class="elem elem--span-7">
              <BasicText>{{ montant.nombreContrats }}</BasicText>
            </div>
            <div class="elem elem--span-7">
              <BasicText>{{ formatNumber(montant.montantHt, { decimal: 2, separateur: true }) + ' €'  }}</BasicText>
            </div>
          </div>
        </div>

        <div class="listCardDesktopWrapper">
          <div class="cardLayoutWrapper cardLayoutWrapper--no-pointer total--row"      >
            <BasicText
              weight="bold"
              class="elem elem--span-36"
            >
              Montant Total : {{ formatNumber(totalHt, { decimal: 2, separateur: true }) + ' €' }}
            </BasicText>
          </div>
        </div>
      </div>

      <!-- Mobile version -->
      <div class="elements--mobile">
        <div
           v-for="(montant, index) in listeMontantsDemandes"
          :key="index"
          class="card"

        >
          <div class="card__header">
            <BasicText weight="bold">
                {{ getModuleLabel(index!) }}
            </BasicText>
          </div>
          <div class="card__content">
            <BasicText>
              <BasicText weight="bold">Heures demandées :</BasicText>
              {{ formatNumber(montant.heuresDemandees, { decimal: 2, separateur: true })  }}
            </BasicText>
            <BasicText wrap>
              <BasicText weight="bold">Taux (€/h) :</BasicText>
              {{ montant.taux }}
            </BasicText>
            <BasicText wrap>
              <BasicText weight="bold">Nombre de contrats :</BasicText>
              {{ montant.nombreContrats }}
            </BasicText>
            <BasicText wrap>
              <BasicText weight="bold">Montant demandé HT :</BasicText>
              {{ formatNumber(montant.montantHt, { decimal: 2, separateur: true }) + ' €' }}
            </BasicText>
          </div>

        </div>
         <div >
              <BasicText weight="bold">Montant Total :</BasicText>
              {{ formatNumber(totalHt, { decimal: 2, separateur: true }) + ' €' }}
          </div>
      </div>
    </template>

  </FormContainer>
</template>

<script setup lang="ts">
  import { DEMANDE_STORE, FormContainer } from '@/features/interface/demande/shared'
import { formatNumber } from '@/features/shared/tools'
import { storeToRefs } from 'pinia'
import { computed, inject } from 'vue'
import { CXPI_MODULES_ACTIONS } from '../../formation/useModuleActions'

  const store = inject(DEMANDE_STORE)!.getStore('MODEL_CXPI')
  const { } = storeToRefs(store)

  const {
    getModuleLabel,
    listeMontantsDemandes
  } = inject(CXPI_MODULES_ACTIONS)!

   const totalHt = computed(() => {
      return Object.values(listeMontantsDemandes.value).reduce(
        (acc, demande) => acc + demande.montantHt,
        0
      )
   })

</script>

<style scoped lang="less">
  .total--row {
    background-color: @neutral-100;
    height: 42px;
  }
</style>
